import React, { useEffect, useState } from "react";
import { CheckBoxLabel } from "../../EventCreation/styles";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { Formik } from "formik";
import FormField from "../FormInputs";
import { FormLabel, Select, Radio } from "@material-ui/core";
import {
  CheckboxContainer,
  CustomCheckBox,
  CustomInputField,
  StyledMenuItem,
} from "../../common/FormInputs";
import { StyledSelectFormControl } from "../../common/CustomSelect/styles";
import { PrimaryCTAButton } from "../../common/Buttons";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import EventService from "../../../services/EventService";
import { Header } from "../Header/Header";
import { navigate, useLocation } from "@reach/router";
import useViewer from "../../../hooks/useViewer";
import "./index.css";
import Footer from "../../Viewer/Header/Footer";
import { scroller } from "react-scroll";
import ViewerService from "../../../services/ViewerService";
//import COLORS from "../../../assets/Colors";
import { ButtonContainer } from "../FormInputs";
/*

import { WhiteSection } from "../LiveEvent";
import Agenda from "../Agenda";
import ProfileContainer from "../ProfileScreen/ProfileContainer";
import Liveresources from "../Liveresources";
import Videos from "../Liveresources/Video";

*/

import LiveTickers from "../Liveresources/Tickers";
//import { HeadingContainer, Header3 } from "../Liveresources/Feedback";
import _ from "lodash";
import { WidthMax, HeroContainerWrap, HeroContainer } from "../Register";
import MenuBurger from "../../common/ActionBar/MenuBurger";
// import MenuTabs from "../MenuBar/Tabs";
import { desiredOrder } from "../../../helpers/constants";
import AgendaTab from "../MenuBar/Agenda";
import SpeakersTab from "../MenuBar/Speakers";
import ResourcesTab from "../MenuBar/Resources";
import VideosTab from "../MenuBar/Videos";
import { getErrorMessage } from "../../../helpers/functions";
import { zoomIn } from "../MenuBar/styles";
import { DrawerContainer } from "../Register";
import GeneralGuidelinesTab from "../MenuBar/GeneralGuidelines";
import FAQs from "../MenuBar/Faqs";

const Index = (props) => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [inputs, setInputs] = useState([]);
  const [initialState, setInitialState] = useState({});
  const [arrayOfObject, setArrayOfObject] = useState();
  const [fields, setFields] = useState({});
  const location = useLocation();
  const { setToken, setGlobalState } = useViewer();
  // const [modal, setModal] = useState({ state: false });

  // const eventId =
  //   location.href.match(/eventId=\d+/)?.[0]?.replace("eventId=", "") || null;

  const params = new URLSearchParams(window.location.search);

  const eventId = params.get("eventId");

  // const eventId = location?.href?.split("eventId=")[1];

  useEffect(() => {
    async function getRegister() {
      try {
        localStorage.removeItem("image");
        setLoader({ state: true, message: "please wait..." });
        const response = await EventService.getRegister(eventId);
        setArrayOfObject(response);
        setGlobalState(response);
        setFields(response?.customFields);
        if (response?.standardField !== null) {
          if (Object.keys(response?.standardField).length !== 0) {
            const orderedArray = desiredOrder
              .filter((key) => response.standardField[key] === true)
              .map((key) => ({
                name: key,
                type: "text",
                label: key
                  .replace(/([A-Z])/g, " $1")
                  .replace(/^./, (str) => str.toUpperCase()), // Convert camelCase to spaced words
                placeholder: `Enter your ${key
                  .replace(/([A-Z])/g, " $1")
                  .replace(/^./, (str) => str.toUpperCase())}`,
                labelHidden: response?.eventSettings?.labelsOutside
                  ? false
                  : true,
              }));
            setInputs([
              ...orderedArray,
              ...(response?.eventSettings?.commonPassword === true
                ? [
                    {
                      type: "password",
                      name: "password",
                      label: "Password",
                      placeholder: "Enter your password",
                      labelHidden: response?.eventSettings?.labelsOutside
                        ? false
                        : true,
                    },
                  ]
                : []),
              ...(response?.eventSettings?.passwordRequired === true
                ? [
                    {
                      type: "password",
                      name: "password",
                      label: "Password",
                      placeholder: "Enter your password",
                      labelColor: response?.theme?.themeGeneral?.labelTextColor,
                      labelHidden: response?.eventSettings?.labelsOutside
                        ? false
                        : true,
                    },
                  ]
                : []),
            ]);
          }
        }
        if (response?.customFields !== null) {
          if (Object.keys(response?.customFields).length !== 0) {
            setInitialState(
              Object.keys(response?.customFields).reduce((acc, key) => {
                const firstFieldType = response?.customFields[key][0]?.type;
                acc[key] =
                  firstFieldType === "checkbox"
                    ? []
                    : firstFieldType === "radio" || firstFieldType === "select"
                    ? ""
                    : "";
                return acc;
              }, {}),
            );
          }
        }
        if (
          !response?.eventSettings?.enableLogins &&
          response?.eventSettings?.enableRegistration &&
          !location?.state?.login
        ) {
          navigate(`/events/register?eventId=${eventId}#home`);
        } else if (
          response?.eventSettings?.enableLogins &&
          response?.eventSettings?.enableRegistration &&
          !location?.state?.login
        ) {
          navigate(`/events/register?eventId=${eventId}#home`);
        } else if (
          !response?.eventSettings?.enableLogins &&
          response?.eventSettings?.enableRegistration &&
          response?.preValidateUsers?.preValidateRegistration &&
          !location?.state?.login
        ) {
          navigate(`/events/register?eventId=${eventId}#home`);
        }

        if (response?.eventTemplate === "AGM") {
          navigate(`/events/agm-live?eventId=${eventId}`);
        }
      } catch (err) {
        enqueueSnackbar(err?.message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
      }
    }
    getRegister(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (eventId) {
      const interval = setInterval(() => {
        (async function getRegister() {
          try {
            localStorage.removeItem("image");
            const response = await EventService.getRegister(eventId);
            setArrayOfObject(response);
            setGlobalState(response);
            setFields(response?.customFields);
            if (response?.standardField !== null) {
              if (Object.keys(response?.standardField).length !== 0) {
                const orderedArray = desiredOrder
                  .filter((key) => response.standardField[key] === true)
                  .map((key) => ({
                    name: key,
                    type: "text",
                    label: key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase()), // Convert camelCase to spaced words
                    placeholder: `Enter your ${key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}`,
                    labelHidden: response?.eventSettings?.labelsOutside
                      ? false
                      : true,
                  }));
                setInputs([
                  ...orderedArray,
                  ...(response?.eventSettings?.commonPassword === true
                    ? [
                        {
                          type: "password",
                          name: "password",
                          label: "Password",
                          placeholder: "Enter your password",
                          labelHidden: response?.eventSettings?.labelsOutside
                            ? false
                            : true,
                        },
                      ]
                    : []),
                  ...(response?.eventSettings?.passwordRequired === true
                    ? [
                        {
                          type: "password",
                          name: "password",
                          label: "Password",
                          placeholder: "Enter your password",
                          labelColor:
                            response?.theme?.themeGeneral?.labelTextColor,
                          labelHidden: response?.eventSettings?.labelsOutside
                            ? false
                            : true,
                        },
                      ]
                    : []),
                ]);
              }
            }
            if (response?.customFields !== null) {
              if (Object.keys(response?.customFields).length !== 0) {
                setInitialState(
                  Object.keys(response?.customFields).reduce((acc, key) => {
                    const firstFieldType = response?.customFields[key][0]?.type;
                    acc[key] =
                      firstFieldType === "checkbox"
                        ? []
                        : firstFieldType === "radio" ||
                          firstFieldType === "select"
                        ? ""
                        : "";
                    return acc;
                  }, {}),
                );
              }
            }
          } catch (err) {
            enqueueSnackbar(err?.message, {
              variant: "error",
            });
          }
        })();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [eventId]); // eslint-disable-line react-hooks/exhaustive-deps

  const getKeys = () => {
    let objctKeys = {};

    inputs.map((item) => (objctKeys[item.name] = ""));
    return { ...objctKeys, ...initialState };
  };

  function transformObject(mainObj, customFieldsTemplate) {
    const customFields = {};
    const newMainObject = { ...mainObj };

    // Extract fields for customFields and remove them from the newMainObject
    Object.keys(customFieldsTemplate).forEach((key) => {
      if (mainObj.hasOwnProperty(key)) {
        customFields[key] = mainObj[key];
        delete newMainObject[key];
      }
    });

    // Return the transformed object
    return {
      ...newMainObject,
      role: "eventviewer",
      customFields,
      eventId: arrayOfObject?.eventId,
    };
  }

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const payload = await transformObject(values, initialState);
      const response = await EventService.eventLoginViewer(payload);
      const responseEventPolling = await ViewerService.syncPollArrayLocallyParticipantAnswered(
             {viewerId:response?.user.id}
            );
      localStorage.setItem("pollArray", JSON.stringify(responseEventPolling.answeredPolls));
      if (arrayOfObject?.livePageSettings?.safeHarborMsg) {
        localStorage.setItem("dsnl_cookies_enabled", false);
        navigate("/safe-harbor", {
          state: {
            arrayOfObject: arrayOfObject,
            eventId: eventId,
            userData: arrayOfObject?.safeHarbor,
            auth_token: response?.token,
            pollArray: JSON.stringify(responseEventPolling.answeredPolls),
          },
        });
      } else {
        enqueueSnackbar("Login successful", {
          variant: "success",
        });
        localStorage.setItem("pollArray", []);
        localStorage.setItem("role", "eventviewer");
        localStorage.setItem("auth_token", response?.token);
        localStorage.setItem("pollArray", JSON.stringify(responseEventPolling.answeredPolls));
        setToken(response?.token);
        navigate("/live");
      }
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const section = props.location.hash.slice(1);
  useEffect(() => {
    scroller.scrollTo(section, {
      duration: 500,
      offset: -70,
      smooth: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location]);

  const {
    resourceSection,
    resourceSetting,
    speakerSection,
    speakerSettings,
    galleryView,
  } = arrayOfObject || {};
  const { resourcesRequired, resourcesVisibility } = resourceSection || {};
  const { speakersRequired, speakersVisibility } = speakerSection || {};

  // Define condition in a variable
  const shouldRenderResources =
    resourcesRequired &&
    (resourcesVisibility === "beforeLogin" ||
      resourcesVisibility === "bothBeforeAfter");

  // Define condition in a variable
  const shouldRenderSpeakers =
    speakersRequired &&
    (speakersVisibility === "beforeLogin" ||
      speakersVisibility === "bothBeforeAfter");

  const shouldRenderAgmHeader =
    arrayOfObject?.eventTemplate === "AGM" && galleryView?.showHeader
      ? true
      : arrayOfObject?.eventTemplate !== "AGM"
      ? true
      : arrayOfObject?.eventTemplate === "AGM" && !galleryView?.showHeader
      ? false
      : true;

  const shouldRenderAgmFooter =
    arrayOfObject?.eventTemplate === "AGM" && galleryView?.showFooter
      ? true
      : arrayOfObject?.eventTemplate !== "AGM"
      ? true
      : arrayOfObject?.eventTemplate === "AGM" && !galleryView?.showFooter
      ? false
      : true;

  const actions = [
    {
      text: "Home",
      props: {
        onClick: () => {
          navigate(`/events/login?eventId=${eventId}#home`);
        },
      },
    },
    {
      text: "Agenda",
      props: {
        onClick: () => {
          navigate("#agenda");
        },
      },
      hidden:
        arrayOfObject?.speakerSection?.speakersRequired &&
        arrayOfObject?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      text: "Speakers",
      props: {
        onClick: () => {
          navigate("#speakers");
        },
      },
      hidden:
        arrayOfObject?.speakerSection?.speakersRequired &&
        arrayOfObject?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      text: "Resources",
      props: {
        onClick: () => {
          navigate("#resources");
        },
      },
      hidden:
        arrayOfObject?.resourceSection?.resourcesRequired &&
        arrayOfObject?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      text: "Videos",
      props: {
        onClick: () => {
          navigate("#videos");
        },
      },
      hidden:
        arrayOfObject?.resourceSection?.resourcesRequired &&
        arrayOfObject?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      text: arrayOfObject?.livePageSettings?.generalGuidelinesLabel
        ? arrayOfObject?.livePageSettings?.generalGuidelinesLabel
        : "General Guidelines Tab",
      props: {
        onClick: () => {
          navigate("#general-guidelines-tab");
        },
      },
      hidden: arrayOfObject?.livePageSettings?.generalGuidelines ? false : true,
    },
    {
      text: "FAQs",
      props: {
        onClick: () => {
          navigate("#faqs");
        },
      },
    },
    {
      text: "Help",
      props: {
        onClick: () => {
          navigate("#help");
        },
      },
    },
  ];

  return (
    <>
      <Layout
        image={arrayOfObject?.theme?.themeGeneral?.backgroundImage}
        bgColor={arrayOfObject?.theme?.themeGeneral?.bodyBackgroundColor}
      >
        <Header showHeader={shouldRenderAgmHeader}>
          {arrayOfObject?.theme?.themeNavigationBar?.navBarTreatment ===
            "alwaysVisible" &&
            shouldRenderAgmHeader && (
              <MenuBurger
                showHeader={shouldRenderAgmHeader}
                {...{ actions }}
                color={
                  arrayOfObject?.theme?.themeNavigationBar?.menuButtonTextColor
                }
                hoverColor={
                  arrayOfObject?.theme?.themeNavigationBar?.menuButtonHoverColor
                }
                menuBackgroundColor={
                  arrayOfObject?.theme?.themeNavigationBar?.menuButtonBgColor
                }
                activeMenuButtonBgColor={
                  arrayOfObject?.theme?.themeNavigationBar
                    ?.activeMenuButtonBgColor
                }
                activeMenuButtonTextColor={
                  arrayOfObject?.theme?.themeNavigationBar
                    ?.activeMenuButtonTextColor
                }
                menuButtonBgColor={
                  arrayOfObject?.theme?.themeNavigationBar?.menuButtonBgColor
                }
              />
            )}
          {(arrayOfObject?.registrationStatus === "open" &&
            arrayOfObject?.eventStatus === "active") ||
          (arrayOfObject?.registrationStatus === "open" &&
            arrayOfObject?.eventStatus === "inactive") ? (
            <WidthMax id="about">
              <HeroContainerWrap id="hero">
                <HeroContainer>
                  {location.href.includes("agenda") ? (
                    shouldRenderSpeakers && (
                      <AgendaTab speakerSettings={speakerSettings} />
                    )
                  ) : location.href.includes("speakers") ? (
                    shouldRenderSpeakers && (
                      <SpeakersTab speakerSettings={speakerSettings} />
                    )
                  ) : location.href.includes("resources") ? (
                    shouldRenderResources && (
                      <ResourcesTab resourceSetting={resourceSetting} />
                    )
                  ) : location.href.includes("videos") ? (
                    shouldRenderResources && (
                      <VideosTab resourceSetting={resourceSetting} />
                    )
                  ) : location.href.includes("general-guidelines-tab") ? (
                    <GeneralGuidelinesTab
                      generalGuidelinesTab={arrayOfObject?.generalGuidelinesTab}
                    />
                  ) : location.href.includes("faqs") ? (
                    <FAQs data={arrayOfObject?.faq} />
                  ) : location.href.includes("help") ? (
                    <FAQs data={arrayOfObject?.help} help={true} />
                  ) : (
                    <Formik
                      initialValues={getKeys()}
                      enableReinitialize
                      onSubmit={onFormSubmit}
                      validationSchema={""}
                      validateOnBlur
                      validateOnChange
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleBlur,
                        handleSubmit,
                        handleChange,
                        resetForm,
                        setFieldValue,
                      }) => (
                        <Container
                          display={
                            arrayOfObject?.standardField
                              ?.registrationformPosition
                          }
                        >
                          <RegisterContainer
                            className={
                              arrayOfObject?.standardField
                                ?.registrationformPosition === "left"
                                ? "start-center"
                                : arrayOfObject?.standardField
                                    ?.registrationformPosition === "right"
                                ? "end-center"
                                : "middle-center"
                            }
                          >
                            {/* <HeadingContainer>
                              <Header3
                                style={{
                                  marginTop: "18px",
                                  marginBottom: "15px",
                                  color:
                                    arrayOfObject?.theme?.themeGeneral
                                      ?.titleTextColor,
                                  fontFamily:
                                    arrayOfObject?.theme?.themeGeneral
                                      ?.titleTextFont,
                                  fontSize: `${arrayOfObject?.theme?.themeGeneral?.titleTextFontSize}px`,
                                }}
                              >
                                {arrayOfObject?.eventTitle}
                              </Header3>
                            </HeadingContainer> */}
                            <form>
                              <Grid grid={inputs.length}>
                                {inputs.map((item, index) => {
                                  return (
                                    <FormField
                                      key={index}
                                      {...{
                                        touched,
                                        errors,
                                        item,
                                        values,
                                        handleChange,
                                        handleBlur,
                                        setFieldValue,
                                      }}
                                      name={item.name}
                                      value={values[item.name]}
                                    />
                                  );
                                })}
                              </Grid>
                              {fields !== null &&
                                Object.keys(fields).map((fieldName) => (
                                  <div key={fieldName}>
                                    <FormLabel
                                      style={{
                                        fontFamily:
                                          theme.fonts.primaryFontSemiBold,
                                        display: arrayOfObject?.eventSettings
                                          ?.labelsOutside
                                          ? "inline"
                                          : "none",
                                        color: "#8294a5",
                                        fontSize: 14,
                                        marginTop: 10,
                                        marginBottom: 10,
                                       
                                      }}
                                    >
                                      {fieldName}
                                    </FormLabel>
                                    {fields[fieldName][0]?.type === "select" ? (
                                      // Single dropdown for dynamic select fields
                                      <div
                                        className="form-fields"
                                        style={{
                                          width: "100%",
                                          marginTop: 10,
                                        }}
                                      >
                                        <StyledSelectFormControl variant="outlined">
                                          <Select
                                            as="select"
                                            name={fieldName}
                                            value={values[fieldName]}
                                            onChange={handleChange}
                                          >
                                            {fields[fieldName].map((option) => (
                                              <StyledMenuItem
                                                key={option.value}
                                                value={option.value}
                                              >
                                                {_.startCase(option.label)}
                                              </StyledMenuItem>
                                            ))}
                                          </Select>
                                        </StyledSelectFormControl>
                                      </div>
                                    ) : (
                                      fields[fieldName].map((field) => {
                                        if (field.type === "text") {
                                          return (
                                            <div
                                              key={field.label}
                                              className="form-fields"
                                              style={{
                                                width: "100%",
                                              }}
                                            >
                                              <CustomInputField
                                                variant="outlined"
                                                style={{ marginTop: 3 }}
                                                value={values[fieldName]}
                                                placeholder={`Enter ${fieldName}`}
                                                name={fieldName}
                                                onChange={handleChange}
                                              />
                                            </div>
                                          );
                                        } else if (field.type === "radio") {
                                          return (
                                            <div
                                              className="form-fields"
                                              style={{
                                                width: "100%",
                                              }}
                                            >
                                              <label>
                                                <Radio
                                                  name={fieldName}
                                                  type="radio"
                                                  value={field.value}
                                                  checked={
                                                    field.value ===
                                                    values[fieldName]
                                                  }
                                                  onChange={handleChange}
                                                />
                                                <CheckBoxLabel>
                                                  {_.startCase(field.label)}
                                                </CheckBoxLabel>
                                              </label>
                                            </div>
                                          );
                                        } else if (field.type === "checkbox") {
                                          return (
                                            <CheckboxContainer>
                                              <CustomCheckBox
                                                name={fieldName}
                                                value={field.value}
                                                checked={values[
                                                  fieldName
                                                ]?.includes(field.value)}
                                                onChange={(e) => {
                                                  const checked =
                                                    e.target.checked;
                                                  const value = e.target.value;
                                                  const updatedValues = checked
                                                    ? [
                                                        ...values[fieldName],
                                                        value,
                                                      ]
                                                    : values[fieldName].filter(
                                                        (v) => v !== value,
                                                      );
                                                  setFieldValue(
                                                    fieldName,
                                                    updatedValues,
                                                  );
                                                }}
                                              />
                                              <CheckBoxLabel>
                                                {field.label}
                                              </CheckBoxLabel>
                                            </CheckboxContainer>
                                          );
                                        }
                                        return null;
                                      })
                                    )}
                                  </div>
                                ))}
                              <ButtonContainer style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                marginTop: "20px", }}>
                                <PrimaryCTAButton
                                  style={{  width: "auto" }}
                                  disabled={
                                    arrayOfObject?.eventSettings
                                      ?.enableLogins &&
                                    !arrayOfObject?.eventSettings
                                      ?.enableRegistration &&
                                    !arrayOfObject?.preValidateUsers
                                      ?.preValidateRegistration
                                  }
                                  onClick={handleSubmit}
                                >
                                  Login
                                </PrimaryCTAButton>
                              </ButtonContainer>
                            </form>
                          </RegisterContainer>
                        </Container>
                      )}
                    </Formik>
                  )}
                </HeroContainer>
              </HeroContainerWrap>
            </WidthMax>
          ) : arrayOfObject?.registrationStatus === "closed" &&
            arrayOfObject?.eventStatus === "inactive" ? (
            <WidthMax id="about">
              <DrawerContainer>
                {(arrayOfObject?.playbackInfo?.playbackRequired &&
                  !arrayOfObject?.playbackInfo?.playbackVideo?.length) ||
                (arrayOfObject?.playbackInfo?.playbackRequired &&
                  arrayOfObject?.playbackInfo?.playbackVideo?.length) ? (
                  <h2>
                    {arrayOfObject?.eventStatus
                      ? "Event status is Inactive / Registration Closed"
                      : null}
                  </h2>
                ) : (
                  <h2>
                    {arrayOfObject?.eventStatus
                      ? "Event status is Inactive / Registration Closed "
                      : null}
                  </h2>
                )}
              </DrawerContainer>
            </WidthMax>
          ) : arrayOfObject?.registrationStatus === "closed" &&
            arrayOfObject?.eventStatus === "active" ? (
            <div style={{ textAlign: "center" }}>
              <WidthMax id="about">
                <DrawerContainer>
                  <h2>
                    {arrayOfObject?.eventStatus
                      ? "Event status is active / Registration Closed "
                      : null}
                  </h2>
                </DrawerContainer>
              </WidthMax>
            </div>
          ) : null}
          {shouldRenderAgmFooter && <Footer />}
        </Header>
      </Layout>
      {arrayOfObject?.livePageSettings?.liveTickers &&
      arrayOfObject?.tickerSettings?.tickerVisibility === "tickerLive" ? (
        <LiveTickers
          messages={[arrayOfObject?.tickerSettings?.tickerText]}
          speed={arrayOfObject?.tickerSettings?.tickerSpeed}
          direction={
            arrayOfObject?.tickerSettings?.tickerDirection === "rightToLeft"
              ? "right"
              : arrayOfObject?.tickerSettings?.tickerDirection === "leftToRight"
              ? "left"
              : "center"
          }
          position={
            arrayOfObject?.tickerSettings?.tickerPosition === "bottomOfThePage"
              ? "bottom"
              : arrayOfObject?.tickerSettings?.tickerPosition === "topOfThePage"
              ? "top"
              : "center"
          }
          tickerTextColor={arrayOfObject?.tickerSettings?.tickerTextColor}
          tickerBgColor={arrayOfObject?.tickerSettings?.tickerBgColor}
          checkIfTrue={arrayOfObject?.galleryView?.showFooter ? true : false}
        />
      ) : null}
    </>
  );
};

export default Index;

export const Grid = styled.div`
  border-radius: 10px;
  @media ${theme?.breakpoints?.sm_up} {
    padding: 0;
    border-radius: 0;
    background-color: transparent;
  }
`;

const RegisterContainer = styled.div`
    width: 570px;
  max-width: 90vw;
  height: auto;
  max-height: 75vh;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  background-color: rgba(255, 255, 255, 0.8);
  // opacity: 0.5;
  jsutify-content: center;
  padding: 20px;
 // margin-top: 50px;
 // margin-bottom: 50px;
  position:fixed;
  overflow-y:scroll;
    &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;     /* Firefox */

    /* Add this at the absolute bottom inside your RegisterContainer */
    /* Add this at the absolute bottom inside your RegisterContainer */
  @media (orientation: landscape) and (max-height: 500px) {
    position: absolute;
    
    /* Adjust these heights to match your exact header and footer sizes */
    top: 80px;       /* Pushes form down, out from behind the header */
    bottom: 70px;    /* Pulls form up, out from behind the footer */
    
    max-height: calc(100vh - 150px); /* Keeps internal scrolling locked inside the visible area */
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: ${({ display }) =>
    display === "left"
      ? "flex-right"
      : display === "right"
        ? "flex-end"
        : "center"};
  align-items: center;
  position: relative;
  height:100vh;
  overflow:hidden;

  `;

export const Layout = styled.div`
  max-height: 100vh;
  height: 100%;
  // overflow-x: hidden;
  overflow-y: scroll;
  scrollbar-width: none; /* Hide scrollbar in Firefox */
  background: ${({ image, bgColor }) =>
    image ? `url(${image}) no-repeat center center` : bgColor};
  background-size: cover;
  // animation: ${zoomIn} 5s ease-in-out;
  // backface-visibility: visible !important;
`;
